import React from 'react';
import ProjectBreakdownTable, {projectBreakdownTableQuery} from './ProjectBreakdownTable';
import {useTrackPage} from '../../../../tracking/amplitude/hooks/useTrackPage';
import {ForecastQueryRenderer} from '../../../../ForecastQueryRenderer';

interface ProjectBreakdownPageProps {
	projectId: string;
	budgetType: string;
}

const ProjectBreakdownPage = ({projectId, budgetType}: ProjectBreakdownPageProps): JSX.Element => {
	useTrackPage('Project Financials Breakdown', {}, {budgetType: budgetType});
	window.history.replaceState(null, '', `${location.pathname}#breakdown`);

	return (
		<>
			<ForecastQueryRenderer
				query={projectBreakdownTableQuery}
				variables={{
					projectId: `${projectId}`,
				}}
				authorizeAccessRoute={'project-budget'}
				render={relayProps => {
					return <ProjectBreakdownTable key={'ProjectBreakdownTable'} {...relayProps} />;
				}}
			/>
		</>
	);
};

export default ProjectBreakdownPage;
